export enum ConfirmOrderResultErrorCodeEnum {
    GeneralError = -1,
    NoError = 0,
    NotAuthenticated = 1,
    CartCookieMissing = 2,
    GetCartDataError = 3,
    WavesClientIDZero = 4,
    InsertOrderError = 5,
    GetOrderError = 6,
    BridgerPayCreatePaymentError = 7,
    ZoozChargeError = 8,
    CompleteOrderError = 9,
    TaxCountryStateInvalid = 10,
    CreatePaymentMethodError = 11,
    CreateCustomerError = 12,
    ZipCodeErrorMessage = 13,
    TotalPriceChanged = 14,
    ValidateCartUserSPError = 15,
    SKUShippingUSCanadaError = 16,
    ShippingCodeMissing = 17,
    ShippingAddressMissing = 18,
    CreateTokenError = 19,
    CreateAuthorizationError = 20,
    SubscriptionDebitNotAllowed = 21,
    PaymentMethodTokenMissing = 22,
    WavesUpdatePlanError = 23,
    UpgradeError = 24,
    NoActiveItems = 25,
    BridgerPayTransactionDataError = 26,
    WebhookBreakPoint = 27,
    ITDevInsertZoozOrderError = 28,
    InsertSubscriptionOrderError = 29,
    InsertWUPOrderError = 30,
    InsertUPGOrderError = 31,
    InsertMasteringOrderError = 32,
    BridgerPayEncryptCvvFailed = 33,
    StateDoesntMatchZipCode = 34,
    TotalPriceChangedFreeTrialAbuse = 35,
}